


















































































































































import Vue from "vue";
import * as types from "../../store/types";
import { rules, scrollToFirstInvalidElement } from "../../services/validation";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "ApplicationStep4",

  props: {},

  data: () => {
    return {
      rules,
      formValue: {
        clienteleRaceWhite: "",
        clienteleRaceBlack: "",
        clienteleRaceLatino: "",
        clienteleRaceNative: "",
        clienteleRaceAsian: "",
        clienteleRaceMore: "",
        clienteleRaceOther: "",
        clienteleRaceUnsure: "",
        clienteleGenderMale: "",
        clienteleGenderFemale: "",
        clienteleGenderTrans: "",
        clienteleGenderNonbinary: "",
        clienteleGenderUnsure: "",
      },
    };
  },

  methods: {
    ...mapActions({
      saveStep: types.SAVE_FORM_STEP,
    }),
    saveAndContinue() {
      this.saveStep({
        formFields: this.formValue,
      }).then(() => {
        // sometimes this if firing before the application-level validation, which reset the validation state, so we wait a little longer to be safe.
        setTimeout(() => {
          // @ts-ignore
          const isValid = this.$refs.form.validate();
          this.$emit("update-validity", 2, isValid);
          if (!isValid) {
            return scrollToFirstInvalidElement(this, this.$refs.form as Vue);
          }

          this.$emit("next-step");
        }, 500);
      });
    },
    save() {
      this.saveStep({
        formFields: this.formValue,
      });
    },
    updateValidity() {
      // @ts-ignore
      const formIsValid = this.$refs.form.validate();
      // @ts-ignore
      this.$refs.form.resetValidation();

      this.$emit("update-validity", 3, formIsValid);
    },
  },

  computed: {
    ...mapGetters({
      allFormValues: types.FORM_VALUES,
      saving: types.SAVING_FORM,
      currentStep: types.CURRENT_STEP,
    }),
  },

  watch: {
    allFormValues: {
      immediate: true,
      handler() {
        // map this step's fields to Vuex's
        Object.keys(this.formValue).forEach(
          // @ts-ignore
          (key) => (this.formValue[key] = this.allFormValues[key])
        );

        setTimeout(() => this.updateValidity(), 50);
      },
    },
  },
});
